module.exports = __webpack_public_path__ + "img/active2.12474ca4.svg";